<div
  class="buy-search-backdrop"
  [class.active]="desktopSearchOpen || mobileSearchOpen"
  aria-hidden="true"
></div>

<mat-toolbar [class.scrolled]="hover">
  <div class="content">
    <a routerLink="/" class="brand">
      <img src="../../../../assets/images/logo.png" alt="环球巴士" />
    </a>
    <div class="space"></div>

    <app-platform-search
      *ngIf="showSearch"
      mode="desktop"
      class="header-search-desktop"
      (openChange)="onSearchOpenChange('desktop', $event)"
    ></app-platform-search>

    <div class="space"></div>

    <div class="right">
      <!-- <button mat-button (click)="goto('popcorn')">
        <img
          src="../../../../assets/images/popcorn/popcorn-logo.webp"
          [width]="20"
          [height]="20"
          alt=""
          style="vertical-align: middle; margin: -9px 5px 0 0"
        />爆米花
      </button>
      <button mat-button (click)="goto('jiegehao')">
        <img
          src="../../../../assets/images/jiegehao/jiegehao.png"
          [width]="20"
          [height]="20"
          alt=""
          style="vertical-align: middle; margin: -5px 5px 0 0"
        />借个号
      </button> -->
      <ng-container *ngIf="!mobile">
        <button
          mat-button
          routerLink="/"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          精选
        </button>
        <button mat-button routerLink="/buy" routerLinkActive="active">
          上车
        </button>
      </ng-container>
      <!-- <button mat-button routerLink="/trending" routerLinkActive="active">
        动态
      </button> -->
      <button mat-button routerLink="/helping" routerLinkActive="active">
        帮助
      </button>
      <button
        mat-button
        routerLink="/user/profile/seats"
        routerLinkActive="active"
      >
        车票
      </button>

      <app-user-avatar-menu></app-user-avatar-menu>
    </div>
  </div>
</mat-toolbar>

<app-platform-search
  *ngIf="showSearch"
  mode="mobile"
  class="header-search-mobile"
  (openChange)="onSearchOpenChange('mobile', $event)"
></app-platform-search>
